"use client";

import { cn } from "@workspace/ui/lib/utils";

type VideoDisplayProps = {
  label: string;
  type: "avatar" | "user";
  isSpeaking?: boolean;
  className?: string;
};

export function VideoDisplay({
  label,
  type = "avatar",
  isSpeaking = false,
  className,
}: VideoDisplayProps) {
  return (
    <div
      className={cn(
        "w-full h-full flex relative bg-[#F3E4C9] rounded-[20px]",
        className,
      )}
    >
      <div
        className={cn(
          "flex absolute top-4 left-4 rounded-lg border-2 border-white/8 shadow-sm px-2 py-1.25 text-[13px] font-semibold leading-4",
          type === "avatar" ? "bg-white" : "bg-[#292524] text-white",
        )}
      >
        {label}
      </div>
    </div>
  );
}
